import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/core';
import { Provider as ReduxProvider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';

// import useMediaQuery from '@material-ui/core/useMediaQuery';
import { I18nextProvider, useTranslation } from 'react-i18next';
import AppProvider from './hooks';
import Routes from './routes';
import { store, persistor } from './store';
import i18n, { loadStoredLanguage } from './i18n';

import GlobalStyles from './styles/Global';
import { lightTheme } from './styles/theme';
import './i18n';

import 'mapbox-gl/dist/mapbox-gl.css';

import Loading from './components/utils/Loading';

const App: React.FC = () => {
  const translation = useTranslation();
  // const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');

  Sentry.init({
    dsn:
      process.env.REACT_APP_ENV === 'dev'
        ? process.env.REACT_APP_SENTRY_KEY_DEV
        : process.env.REACT_APP_SENTRY_KEY,
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0,
  });

  useEffect(() => {
    const storedLanguage = loadStoredLanguage();
    if (storedLanguage !== '') {
      translation.i18n.changeLanguage(JSON.parse(storedLanguage));
    }
  }, [translation.i18n]);

  return (
    <Router>
      <ReduxProvider store={store}>
        <PersistGate loading={Loading} persistor={persistor}>
          <AppProvider>
            <ThemeProvider theme={lightTheme}>
              <I18nextProvider i18n={i18n}>
                <GlobalStyles />
                <Routes />
              </I18nextProvider>
            </ThemeProvider>
          </AppProvider>
        </PersistGate>
      </ReduxProvider>
    </Router>
  );
};

export default App;
